import { HttpErrorResponse } from "@angular/common/http";

import { Message } from "@core/models/message.model";
import { TPagination } from "@custom-types/sorting";
import { createReducer, on } from "@ngrx/store";

import * as MessageActions from "./message.actions";

export const MESSAGES_FEATURE_KEY = "message";

export interface MessageState {
  messages: Array<Message>;
  pagination: Partial<TPagination> | undefined;
  messagesLength: number;
  loading: boolean;
  error: HttpErrorResponse | null;
}

export const initialState: MessageState = {
  messages: [],
  pagination: undefined,
  messagesLength: 0,
  loading: false,
  error: null,
};

export const MESSAGES_REDUCER = createReducer(
  initialState,
  on(
    MessageActions.SET_MESSAGES,
    (
      state: MessageState,
      action: { messageList: Array<Message> }
    ): MessageState => {
      return {
        ...state,
        messages: action.messageList,
      };
    }
  ),
  on(
    MessageActions.SET_MESSAGES_LENGTH,
    (state: MessageState, action: { length: number }): MessageState => {
      return {
        ...state,
        messagesLength: action.length,
      };
    }
  ),
  on(
    MessageActions.SET_MESSAGES_PAGINATION,
    (
      state: MessageState,
      action: { pagination: Partial<TPagination> | undefined }
    ): MessageState => {
      return {
        ...state,
        pagination: action.pagination,
      };
    }
  ),
  on(
    MessageActions.SET_MESSAGES_LOADING_STATUS,
    (state: MessageState, action: { loading: boolean }): MessageState => {
      return {
        ...state,
        loading: action.loading,
      };
    }
  ),
  on(
    MessageActions.SET_MESSAGES_ERROR,
    (
      state: MessageState,
      action: { error: HttpErrorResponse }
    ): MessageState => {
      return {
        ...state,
        error: action.error,
      };
    }
  )
);
